import { useSession } from '@/lib/hooks/useSession';
import { useAppDispatch } from '@/lib/hooks/storeHook';
import { setEmailLoginOpen } from '@/lib/stores/uiSlice';
import { useCallback } from 'react';

export function useLoginRedirect() {
  const { data: sessionData } = useSession();
  const dispatch = useAppDispatch();

  const openLoginModal = useCallback(() => {
    dispatch(setEmailLoginOpen(true));
  }, [dispatch]);

  return {
    isLogin: sessionData?.isLogin ?? false,
    openLoginModal,
  };
}
